import React, { Component, Fragment } from 'react';

var Options = React.forwardRef(function (props, ref) {
  return props.JSX ? React.createElement(
    'div',
    { ref: ref },
    props.JSX(props.value)
  ) : React.createElement(
    'div',
    { ref: ref },
    props.value
  );
});

export default Options;